/**
 * @generated SignedSource<<0eb8312d91cb475f0c0734efbb2a83a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appname"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "provisioning"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "using"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appname",
        "variableName": "appname"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "provisioningaccountname",
        "variableName": "provisioning"
      },
      {
        "kind": "Variable",
        "name": "usingaccountname",
        "variableName": "using"
      }
    ],
    "concreteType": "BindCardAausConnection",
    "kind": "LinkedField",
    "name": "getbindcardbyappandusers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BindCardAau",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bcId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bcLast4",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bcStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerAppId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerAppStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "provisioningAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "provisioningAccountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "usingAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "usingAccountName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BindCardsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "BindCardsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "751175a4a5f4e68fc176e683ec697f35",
    "id": null,
    "metadata": {},
    "name": "BindCardsQuery",
    "operationKind": "query",
    "text": "query BindCardsQuery(\n  $appname: String!\n  $provisioning: String!\n  $using: String!\n  $first: Int\n) {\n  getbindcardbyappandusers(appname: $appname, provisioningaccountname: $provisioning, usingaccountname: $using, first: $first) {\n    totalCount\n    nodes {\n      bcId\n      bcLast4\n      bcStatus\n      customerAppId\n      customerAppStatus\n      appId\n      appName\n      provisioningAccountId\n      provisioningAccountName\n      usingAccountId\n      usingAccountName\n    }\n  }\n}\n"
  }
};
})();

node.hash = "47b1e21d57fd7f4605e329b9de101a44";

module.exports = node;
